export const TiposSolicitantesActionTypes = {
  API_RESPONSE_SUCCESS: '@@tipos-solicitante/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@tipos-solicitante/API_RESPONSE_ERROR',

  GET_TIPO: '@@tipos-solicitante/GET_TIPO',

  LIST_TIPOS: '@@tipos-solicitante/LIST_TIPOS',
  ADD_TIPO: '@@tipos-solicitante/ADD_TIPO',
  UPDATE_TIPO: '@@tipos-solicitante/UPDATE_TIPO',
  UPDATE_ORDER_TIPOS: '@@tipos-solicitante/UPDATE_ORDER_TIPOS',
  DELETE_TIPO: '@@tipos-solicitante/DELETE_TIPO',
  SET_FILTER: '@@tipos-solicitante/SET_FILTER',

  RESET: '@@tipos-solicitante/RESET',
  RESET_SOFT: '@@tipos-solicitante/RESET_SOFT'
}
